import { PublicLayout } from "@/components/layout/PublicLayout";
import { LEGAL_UPDATED } from "@/data/legal";

export const LegalPage = ({ title, intro, sections, testid }) => {
  return (
    <PublicLayout>
      <div className="mx-auto max-w-3xl px-5 py-16 md:py-24" data-testid={testid}>
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-blue-600">
          Legal
        </p>
        <h1 className="mt-3 font-display text-4xl font-bold tracking-tight text-slate-900 sm:text-5xl">
          {title}
        </h1>
        <p className="mt-3 text-sm text-slate-400">Last updated: {LEGAL_UPDATED}</p>
        {intro && (
          <p className="mt-6 leading-relaxed text-slate-600">{intro}</p>
        )}

        <div className="mt-10 space-y-8">
          {sections.map((s) => (
            <section key={s.heading}>
              <h2 className="font-display text-lg font-semibold tracking-tight text-slate-900">
                {s.heading}
              </h2>
              <p className="mt-2 leading-relaxed text-slate-600">{s.body}</p>
            </section>
          ))}
        </div>
      </div>
    </PublicLayout>
  );
};
